import { Award, Eye, ShieldCheck } from "lucide-react";

interface Props {
  name: string;
  description: string;
  achievementType: string;
  imagePath: string;
  expiryDurationDays?: string;
  certificateLinked: boolean;
}

const ACHIEVEMENT_LABEL: Record<string, string> = {
  Badge: "Badge",
  MicroCredential: "Micro-credential",
  Achievement: "Achievement",
  Recognition: "Recognition",
};

/**
 * Live mock of the public verification card — what visitors see when they
 * open the shared badge URL. Updates as the admin types in the modal.
 */
const BadgePreview: React.FC<Props> = ({
  name,
  description,
  achievementType,
  imagePath,
  expiryDurationDays,
  certificateLinked,
}) => {
  const expiryText = expiryDurationDays
    ? Number(expiryDurationDays) >= 365
      ? `${(Number(expiryDurationDays) / 365).toFixed(0)} yr`
      : `${expiryDurationDays} days`
    : "Never";

  return (
    <div className="bm-preview-sticky">
      <div className="bm-preview-label">
        <Eye size={12} /> Live preview
      </div>
      <div className="bm-preview-card">
        <div className="bm-preview-banner" />
        <div className="bm-preview-image-wrap">
          {imagePath ? (
            <img src={imagePath} alt="Badge" />
          ) : (
            <Award size={42} className="bm-preview-image-placeholder" />
          )}
        </div>
        <div className="bm-preview-body">
          <span className="bm-preview-type-pill">
            {ACHIEVEMENT_LABEL[achievementType] || achievementType || "Badge"}
          </span>
          <h3 className="bm-preview-name">{name || "Untitled badge"}</h3>
          {description ? <p className="bm-preview-desc">{description}</p> : null}
          <hr className="bm-preview-divider" />
          <div className="bm-preview-meta">
            <div className="bm-preview-meta-item">
              <span className="label">Validity</span>
              <span className="value">{expiryText}</span>
            </div>
            <div className="bm-preview-meta-item">
              <span className="label">Certificate</span>
              <span className="value">{certificateLinked ? "Linked" : "None"}</span>
            </div>
          </div>
          <span className="bm-preview-verified">
            <ShieldCheck size={12} /> Cryptographically verifiable
          </span>
          <div className="bm-preview-note">Preview only — colours match the chosen verification template.</div>
        </div>
      </div>
    </div>
  );
};

export default BadgePreview;
